/**
 * @generated SignedSource<<2b4cb869703c0c0a833c52c5c2add1f1>>
 * @relayHash 5895fa2f83461fd9120b1ab16cf97516
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a62f95dd0f427cc2fe7ec5a8457c6b9d2ef65632c4ba2f7be3997bf7d72445cd

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraSoftwareTimelineAppQuery } from './JiraSoftwareTimelineAppQuery.graphql';

const node: PreloadableConcreteRequest<JiraSoftwareTimelineAppQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "a62f95dd0f427cc2fe7ec5a8457c6b9d2ef65632c4ba2f7be3997bf7d72445cd",
    "metadata": {},
    "name": "JiraSoftwareTimelineAppQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
